module.exports = __webpack_public_path__ + "img/ru.0d00bb62.svg";